<div class="vindication-feature">
	<app-navbar title="Faktury" [showReservationSearch]="false">
		<button (click)="goToMailView()" color="primary" mat-raised-button>Generuj mail</button>
	</app-navbar>

	<div class="vindication-body">
		<div class="vindication-top m-3">
			<mat-accordion>
				<mat-expansion-panel (opened)="isFiltersOpened.set(true)" (closed)="isFiltersOpened.set(false)">
					<mat-expansion-panel-header>
						<mat-panel-title>
							<i class="fa fa-filter"></i><span class="ms-2 font-wegiht-700">Filtry</span>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<app-invoice-filters
						[internalStatusOptions]="internalStatusOptions()"
						[issuedByOptions]="issuedByOptions()"
						(showFiltersBtnClick)="applyFilters($event)"
					></app-invoice-filters>
				</mat-expansion-panel>
			</mat-accordion>

			<div class="mt-3 d-flex justify-content-end">
				<button
					mat-raised-button
					(click)="openColumnSelectorDialog()"
					type="button"
					matTooltip="Wybierz kolumny"
				>
					<i class="fa fa-columns"></i>
					<span class="ms-1">Kolumny</span>
				</button>
			</div>
		</div>

		<div class="dynamic-table">
			<mat-table class="w-100" matSort (matSortChange)="onSortChange($event)" [dataSource]="dataSource">
				<ng-container sticky matColumnDef="checkbox">
					<mat-header-cell *matHeaderCellDef>
						<mat-checkbox
							color="primary"
							[checked]="allSelected()"
							(change)="toggleAllRows()"
							[indeterminate]="selection().length > 0 && !allSelected()"
						>
						</mat-checkbox>
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<mat-checkbox
							color="primary"
							[checked]="selectedIds().has(element.id)"
							(click)="$event.stopPropagation()"
							(change)="toggleRow(element)"
						>
						</mat-checkbox>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="amount">
					<mat-header-cell *matHeaderCellDef mat-sort-header="amount">Kwota</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.amount }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="amountWithVat">
					<mat-header-cell *matHeaderCellDef mat-sort-header="amount_with_vat">Kwota z VAT</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.amountWithVat }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="currency">
					<mat-header-cell *matHeaderCellDef mat-sort-header="currency">Waluta</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.currency }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="vat">
					<mat-header-cell *matHeaderCellDef mat-sort-header="vat">VAT</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.vat }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="ourCompany">
					<mat-header-cell *matHeaderCellDef mat-sort-header="our_company">Sprzedawca</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.ourCompany?.fullName }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="shortName">
					<mat-header-cell *matHeaderCellDef mat-sort-header="contractor__short_name"
						>Kontrahent</mat-header-cell
					>
					<mat-cell *matCellDef="let element">{{ element.contractor?.shortName }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="mail">
					<mat-header-cell *matHeaderCellDef mat-sort-header="contractor__mails">Maile</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.contractor?.mails | mailArray }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="prefix">
					<mat-header-cell *matHeaderCellDef>Prefix</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.contractor?.prefix }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="nip">
					<mat-header-cell *matHeaderCellDef mat-sort-header="contractor__nip">NIP</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.contractor?.nip }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="number">
					<mat-header-cell *matHeaderCellDef mat-sort-header="number">Numer fv</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.number }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="afterPaymentDays">
					<mat-header-cell *matHeaderCellDef mat-sort-header="days_after_deadline"
						>Dni po terminie</mat-header-cell
					>
					<mat-cell *matCellDef="let element">
						{{ element?.daysAfterDeadline ?? '-' }}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="delayDays">
					<mat-header-cell *matHeaderCellDef mat-sort-header="deferred_payment_days"
						>Dni odroczenia</mat-header-cell
					>
					<mat-cell *matCellDef="let element">
						{{ element?.deferredPaymentDays ?? '-' }}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="carrierReference">
					<mat-header-cell *matHeaderCellDef mat-sort-header="carrier_reference"
						>Referencja przewoźnika</mat-header-cell
					>
					<mat-cell *matCellDef="let element">{{ element.carrierReference ?? '-' }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="paymentDeadlineFromSend">
					<mat-header-cell *matHeaderCellDef mat-sort-header="payment_deadline_from_send"
						>Termin płatności od daty korespondencji</mat-header-cell
					>
					<mat-cell *matCellDef="let element">{{
						(element?.paymentDeadlineFromSend | date: 'dd.MM.yyyy') ?? '-'
					}}</mat-cell>
				</ng-container>
				<ng-container matColumnDef="paymentDeadline">
					<mat-header-cell *matHeaderCellDef mat-sort-header="payment_deadline"
						>Termin płatności</mat-header-cell
					>
					<mat-cell *matCellDef="let element">{{
						(element?.paymentDeadline | date: 'dd.MM.yyyy') ?? '-'
					}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="paymentTime">
					<mat-header-cell *matHeaderCellDef mat-sort-header="payment_time">Data zapłaty</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.paymentTime | date: 'dd.MM.yyyy' }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="declaredPaymentDate">
					<mat-header-cell *matHeaderCellDef mat-sort-header="declared_payment_date"
						>Deklarowany termin płatności</mat-header-cell
					>
					<mat-cell *matCellDef="let element">
						<app-inline-edit
							[value]="element.declaredPaymentDate ?? ''"
							[isLoading]="element.declaredPaymentDateLoader"
							inputType="date"
							(save)="saveDeclaredPaymentDate(element, $event)"
						/>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="issueDate">
					<mat-header-cell *matHeaderCellDef mat-sort-header="issue_date">Data wystawienia</mat-header-cell>
					<mat-cell *matCellDef="let element">{{
						(element?.issueDate | date: 'dd.MM.yyyy') ?? '-'
					}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="status">
					<mat-header-cell *matHeaderCellDef mat-sort-header="status">Status płatności</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.status | statusVindicationLabel }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="internalStatus">
					<mat-header-cell *matHeaderCellDef mat-sort-header="internal_status__name"
						>Status wewnętrzny</mat-header-cell
					>
					<mat-cell *matCellDef="let element">
						<app-inline-edit
							[value]="element.internalStatus?.id ?? null"
							[isLoading]="element.internalStatusLoader"
							inputType="select"
							[options]="internalStatusOptions()"
							(save)="saveInternalStatus(element, $event)"
						/>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="shouldVindicate">
					<mat-header-cell *matHeaderCellDef mat-sort-header="should_vindicate"
						>Windykacja automatyczna</mat-header-cell
					>
					<mat-cell *matCellDef="let element">{{ element.shouldVindicate ? 'Tak' : 'Nie' }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="navigatorId">
					<mat-header-cell *matHeaderCellDef mat-sort-header="navigator_id">Nawigator ID</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.navigatorId }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="mailsSent">
					<mat-header-cell *matHeaderCellDef mat-sort-header="mailsent">Mail wysłany</mat-header-cell>
					<mat-cell *matCellDef="let element">
						@if (element.mailsSentAutomatically > 0 || element.mailsSentManually > 0) {
							Tak
						} @else {
							Nie
						}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="note">
					<mat-header-cell *matHeaderCellDef>Notatka</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<app-inline-edit
							[value]="element.note ?? ''"
							[isLoading]="element.noteLoader"
							inputType="text"
							(save)="saveNote(element, $event)"
						/>
					</mat-cell>
				</ng-container>

				<ng-container stickyEnd matColumnDef="mailsSentAction">
					<mat-header-cell *matHeaderCellDef></mat-header-cell>
					<mat-cell *matCellDef="let element">
						<button mat-raised-button color="primary" (click)="openMailsSent(element.number)">
							Wysłane maile
						</button>
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns()"></mat-row>
			</mat-table>

			@if (isLoading()) {
				<div class="spinner-container">
					<mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
				</div>
			}
		</div>
	</div>

	<mat-paginator
		class="vindication-paginator"
		[length]="length()"
		[pageSize]="pageSize()"
		[pageIndex]="pageIndex()"
		[pageSizeOptions]="[5, 10, 25, 100]"
		(page)="onPageChange($event)"
	>
	</mat-paginator>
</div>
